<div class="btn-group">
  <button class="btn btn__filter btn-clear btn-sm dropdown-toggle font-bold p-0" type="button" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false" id="sortDropdownBtn" aria-labelledby="sortBy">
    <span class="sr-only sr-only-focusable" id="sortBy">{{labelFor +', '+ selectedSortOption }}</span>
    {{ selectedSortOption }}
  </button>

  <div class="dropdown-menu dropdown-menu-right px-2">
    <button *ngFor="let data of sortOptions" class="btn btn-clear font-2x dropdown-item"
      (click)="sortData($event, data.type, data.isDate, data.isAsce,data)" [attr.aria-label]="data.display+ ' option'">{{data.display}}</button>
  </div>
</div>
